(() => {
  const collectionHandleBtnSelector = '[js-cus-collection-btn]';
  const mainCollectionContainerSelector = '[js-main-collection-container ]';
  //const collectionTitleSelector = '[js-collection-title]';

  function fetchData(handle){
    window.history.pushState('','', `${location.origin}/collections/${handle}`)

    const mainCurrentCollectionContainer = document.querySelector(mainCollectionContainerSelector);
    const sectionId = mainCurrentCollectionContainer.dataset.sectionId;
    const url = `${location.origin}/collections/${handle}?section_id=${sectionId}`;
    fetch(url)
      .then(response => {
        return response.text()
      })
      .then(doc => {
        const parser = new DOMParser()
        const html = parser.parseFromString(doc, 'text/html')
        const ajaxCollection = html.querySelector(mainCollectionContainerSelector)
        document.querySelector(mainCollectionContainerSelector).replaceWith(ajaxCollection);
        document.dispatchEvent(new CustomEvent("product-grid-slider:init"))
        document.dispatchEvent(new CustomEvent("quickAddToCart:init"))
        document.dispatchEvent(new CustomEvent("zip-checker:init"))
      })
  }

  document.querySelectorAll(collectionHandleBtnSelector).forEach(btn => {
    btn.addEventListener('click', (e) => {
        document.querySelectorAll(collectionHandleBtnSelector).forEach(btn => {
          btn.classList.remove('active');
        })
        const collectionHandle = btn.dataset.collectionHandle;
        //document.querySelector(collectionTitleSelector).innerHTML = btn.dataset.collectionTitle; 
        btn.classList.add('active')
        fetchData(collectionHandle)
    })
  })

})()